import { createContext } from "react";

export const LoggedInContext = createContext();
export const LanguageContext = createContext();
export const GeoIpContext = createContext();
